import axios from "axios";
import React from "react";
import { getRequest } from "./QuoteApiService";

export const getSLAs = (tenantId) => {
    const call = getRequest('GetSLAs/' + tenantId);

    console.log("userServices > getSLAs called...");
    return new Promise((resolve, reject) => {
      try {
        axios
        .all([call])
        .then((res) => {
          console.log("getSLAs > axios res=", res);
          resolve(res);
        })
        .catch((err) => {
          console.log("getSLAs > axios err=", err);
          reject("Error in getSLAs axios!");
        });
      } catch (error) {
        console.error("in services > getSLAs, Err===", error);
        //reject(SYSTEM_ERROR);
      }
    });
  
}
